// state
import * as types from '~/store/mutation-types'

export const state = {
  isEdit: false,
  withCreateActiveOrderProduct: false,
  formDataObj: {}
}

// getters
export const getters = {
}

// mutation
export const mutations = {
  [types.SET_ADD_EDIT_ORDER_MODAL_IS_EDIT] (state, payload) {
    state.isEdit = payload
  },
  [types.SET_ADD_EDIT_ORDER_MODAL_WITH_CREATE_ACTIVE_ORDER_PRODUCT] (state, payload) {
    state.withCreateActiveOrderProduct = payload
  },
  [types.SET_ADD_EDIT_ORDER_MODAL_FORM_DATA_OBJ] (state, { formDataObj }) {
    state.formDataObj = formDataObj
  }
}

// actions
export const actions = {
  setAddEditOrderModelWithCreateActiveOrderProduct ({ commit }, payload) {
    commit(types.SET_ADD_EDIT_ORDER_MODAL_WITH_CREATE_ACTIVE_ORDER_PRODUCT, payload)
  }
}
